/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{makeHandle as e}from"../../core/handleUtils.js";function i(i){const t=()=>i("visible"===document.visibilityState);return document.addEventListener("visibilitychange",t),e((()=>document.removeEventListener("visibilitychange",t)))}export{i as onVisibilityChange};
